require('../../hosting/polyfill');
import { app, renderAsApp } from '@ekuaibao/whispered';
app.callback().then(function (dom) { return renderAsApp(dom); });
